"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const color_1 = __importDefault(require("color"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
const usStates_1 = require("./usStates");
const util_1 = require("./util");
const Triggerable_1 = __importDefault(require("../../util/Triggerable"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const chart_helpers_1 = require("../../util/chart.helpers");
require("./Cartogram.scss");
const constants_1 = require("../../constants");
function showTooltip(cartoDatum, cartoHex) {
  const containerDim = this.container.node().getBoundingClientRect();
  const tooltipColour = 'black';
  const topContent = {
    title: {
      value: null
    },
    subtitle: {
      value: null
    }
  };
  const {
    x,
    y,
    width,
    height
  } = cartoHex.getBoundingClientRect();
  const tooltipText = this.cachedParams.cartogramOptions.tooltipTextFunction(cartoDatum);
  this.tooltip.draw(x - containerDim.left + width / 2, y - containerDim.top + height / 2, topContent, [{
    type: 'value',
    value: tooltipText,
    html: true
  }], {
    primaryColour: tooltipColour
  }, 4);
}
class Cartogram extends Triggerable_1.default {
  constructor(container) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    const {
      width,
      height,
      hide,
      standalone = true
    } = options;
    const d3Container = (0, chart_helpers_1.getD3Selection)(container);
    if (d3Container === null) {
      throw new Error('[Cartogram] Constructor argument is not an Element or D3 selection, or two instances of D3 are being used');
    }
    if (standalone) {
      this.container = d3Container.append('svg').classed('cartogram-standalone', true);
    } else {
      this.container = d3Container;
    }
    this.containerG = this.container.append('g').classed('cartogram', true);
    this.width = width || 1000;
    this.height = height || 600;
    this.stroke = 4;
    this.scale = 2;
    this.standalone = standalone;
    this.tooltip = new Tooltip_1.default(d3Container);
    this.initializeMap(hide, standalone);
  }
  // override
  on(tag, action) {
    super.on(tag, action);
    this.setListeners();
  }
  setListeners() {
    let listenersActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let mouseMove = null;
    let mouseOut = null;
    let click = null;
    const hexes = this.containerG.selectAll('g.cartogram-hex .inner-polygon');
    if (listenersActive) {
      mouseMove = lodash_1.default.throttle((event, d) => {
        this.setHovered(d.properties.fips);
        this.trigger('hover', d, event);
        if (this.cachedParams && this.cachedParams.cartogramOptions.tooltipTextFunction && d.properties.fips !== 'US') {
          showTooltip.call(this, d, event.currentTarget);
          event.stopPropagation();
        }
      }, constants_1.THROTTLE, {
        trailing: false
      });
      mouseOut = () => {
        this.setHovered(null);
        this.tooltip.hide();
        this.trigger('mouseout');
      };
      click = (event, d) => {
        this.trigger('click', d);
      };
    }
    hexes.on('mousemove', mouseMove, {
      passive: true
    }).on('mouseout', mouseOut, {
      passive: true
    }).on('click', click, {
      passive: true
    });
  }
  initializeMap(hide, standalone) {
    if (hide) {
      this.containerG.classed('hidden', true);
    }
    this.drawUSA((0, usStates_1.stateIdx)(usStates_1.statesGrid));
    this.setListeners();
    if (standalone) {
      this.ro = new resize_observer_polyfill_1.default(entries => {
        entries.forEach(entry => {
          const {
            width: containerWidth
          } = entry.contentRect;
          if (this.width === containerWidth || containerWidth === 0) {
            return;
          }
          requestAnimationFrame(() => {
            this.width = containerWidth;
            this.redraw();
          });
        });
      });
      this.ro.observe(this.container.node());
    }
  }
  drawUSA(data, options) {
    this.containerG.selectAll('g.cartogram-hex').data(data, d => d.fips || d.selector).join(enter => {
      const groups = enter.append('g').classed('cartogram-hex', true);
      groups.append('polygon').classed('outer-polygon', true);
      groups.append('polygon').classed('inner-polygon', true);
      groups.append('text').classed('cartogram-label', true);
      return groups;
    }, update => update);
    const hexGroups = this.containerG.selectAll('g.cartogram-hex');
    hexGroups.select('.outer-polygon').attr('points', d => (0, util_1.hexPolygon)(d, this.width, this.stroke, d.properties.fips === 'US' && options.cartogramOptions.makeUSABigger).map(points => points.join(',')));
    hexGroups.select('.inner-polygon').attr('points', d => (0, util_1.hexInnerPolygon)(d, this.width, this.stroke, this.stroke / 2, d.properties.fips === 'US' && options.cartogramOptions.makeUSABigger).map(points => points.join(','))).style('stroke-width', this.stroke / 2).style('stroke', 'white');
    hexGroups.select('.cartogram-label').attr('x', _ref => {
      let {
        i,
        j
      } = _ref;
      return (0, util_1.hexDimensions)(i, j, this.width, this.stroke).x;
    }).attr('y', d => (0, util_1.hexDimensions)(d.i, d.j, this.width, this.stroke, d.properties.fips === 'US' && options.cartogramOptions.makeUSABigger).y).text(d => d.properties.abbr);
    d3.selectAll('g.cartogram-hex.selected').raise();
  }
  draw() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.cachedParams = options;
    if (this.standalone) {
      this.container.attr('viewBox', `0 0 ${this.width} ${this.height}`);
    }
    const {
      cartogramOptions
    } = options;
    if (options.usaData && cartogramOptions.showUSA) {
      this.drawUSA((0, usStates_1.stateWithUSAIdx)(usStates_1.USGrid), options);
      this.containerG.selectAll('g.cartogram-hex').classed('usa', d => d.properties.fips === 'US');
    } else {
      this.drawUSA((0, usStates_1.stateIdx)(usStates_1.statesGrid), options);
    }
    this.setSelected(options);
    this.setPointerEvents(options);
  }
  setSelected() {
    let {
      cartogramOptions,
      selectedStates
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const colourFunction = cartogramOptions.colourFunction || (() => colours_module_scss_1.default.chartcolourgreycartogram);
    const outlineFunction = cartogramOptions.outlineFunction || (() => 'white');
    const groups = this.containerG.selectAll('g.cartogram-hex').attr('fill', d => (0, util_1.fillColour)(d, colourFunction, cartogramOptions, false));
    groups.selectAll('text.cartogram-label').style('fill', d => {
      if (cartogramOptions.autoLabelColour && (0, color_1.default)((0, util_1.fillColour)(d, colourFunction, cartogramOptions, false)).isDark()) {
        return 'white';
      }
      if (cartogramOptions.lighterUnselectedText) {
        return '#999999';
      }
      return null;
    });
    if (cartogramOptions.selectableCartogram) {
      groups.classed('selected', d => lodash_1.default.some(selectedStates, dd => dd === d.properties.fips));
    }
    const selectedGroups = d3.selectAll('g.cartogram-hex.selected').raise();
    selectedGroups.attr('fill', d => (0, util_1.fillColour)(d, colourFunction, cartogramOptions, true));
    selectedGroups.select('polygon').style('stroke', d => outlineFunction(d));
    selectedGroups.selectAll('text.cartogram-label').style('fill', d => {
      if (cartogramOptions.autoLabelColour && (0, color_1.default)((0, util_1.fillColour)(d, colourFunction, cartogramOptions, true)).isDark()) {
        return 'white';
      }
      return null;
    });
    this.setListeners();
  }
  setHovered(hoveredFips) {
    const {
      cartogramOptions,
      selectedStates
    } = this.cachedParams;
    const colourFunction = cartogramOptions.colourFunction || (() => colours_module_scss_1.default.chartcolourgreycartogram);
    this.containerG.selectAll('g.cartogram-hex:not(.selected)').attr('fill', d => {
      const colour = (0, util_1.fillColour)(d, colourFunction, cartogramOptions, false);
      if (d.properties.fips === hoveredFips && selectedStates && selectedStates.find(dd => dd === d.properties.fips) === undefined && cartogramOptions.fillHovered) {
        return cartogramOptions.fillHovered(d, colour);
      }
      return colour;
    });
  }
  redraw() {
    if (this.cachedParams) {
      this.draw(...this.cachedParams);
    }
  }
  setPointerEvents() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      cartogramOptions
    } = options;
    if (cartogramOptions.disabled) {
      this.containerG.selectAll('g').style('opacity', '0.3');
      this.setListeners(false);
    } else {
      this.containerG.selectAll('g').style('opacity', '1');
      this.setListeners();
    }
  }
}
exports.default = Cartogram;